import send from '../../utils/fetch'

const state = {
    domains: [],
}

const actions = {
    async GET_ALL_DOMAINS({ commit, getters, dispatch }) {
        try {
            let response = await send(global.$url.settings_domains.get, 'GET')
                .then(response => response.data.result)
            await dispatch('fetch', {url: global.$url.team.get, mutation: 'SET_TEAMS'})

            response = response.map(domain => {
                const landings = domain.campaigns.map(item => item.name)
                const team = getters.teams.find(team => team.id === domain.team_id)
                const affiliate = team.users.find(affiliate => affiliate.hash === domain.affiliate_hash)

                domain.landingsList = landings
                domain.landingsLength = landings.length
                domain.team_name = team ? team.name : ''
                domain.affiliate_name = affiliate ? affiliate.name : ''
                domain.active_name = domain.is_active ? 'On' : 'Off'

                return domain
            })

            commit('SET_DOMAINS', response.reverse())
            return response
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async GET_TEAM_DOMAINS({ commit, getters, dispatch }) {
        try {
            const {data} = await send(global.$url.domains.get, 'GET')
            await dispatch('fetch', {url: global.$url.team.get, mutation: 'SET_TEAMS'})

            data.result.map((res, index) => {
                getters.teams.map(team => {
                    if (team.id === res.team_id) {
                        data.result[index].team = team
                    }
                })
            })

            commit('SET_DOMAINS', data.result.reverse())
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async UPDATE_STATUS_DOMAIN({ dispatch }, {id}) {
        try {
            const {data} = await send(global.$url.settings_domains.destroy, 'DELETE', {data: {id}})
            await dispatch('GET_ALL_DOMAINS')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async ADD_DOMAIN({ dispatch }, domain) {
        try {
            const {data} = await send(global.$url.settings_domains.create, 'POST', {data: domain})
            dispatch('GET_ALL_DOMAINS', )
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async EDIT_DOMAIN({ dispatch }, domain) {
        try {
            const {data} = await send(global.$url.settings_domains.update, 'PUT', {data: domain})
            dispatch('GET_ALL_DOMAINS')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    //Transfer domains
    async GET_ALL_TRANSFER_DOMAINS({commit, dispatch, getters}) {
        try {
            const {data} = await send(global.$url.domains.all, 'GET')
            commit('SET_DOMAINS', data.result.reverse())
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async EDIT_TRANSFER_DOMAINS({dispatch}, domains) {
        try {
            const {data} = await send(global.$url.domains.update, 'POST', {data: domains})
            await dispatch('GET_ALL_TRANSFER_DOMAINS')
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },
}

const mutations = {
    SET_DOMAINS(state, data) {
        state.domains = data
        state.testDomain = data
    }
}

const getters = {
    domains: (state) => state.domains,
}

export default {
    state,
    actions,
    mutations,
    getters
}
